// Dates reach Vue as UTC instants. Format them in the app's own timezone
// (config('app.timezone'), passed through as VITE_APP_TIMEZONE) rather than
// the runtime's: the SSR node process runs in UTC and a visitor's browser in
// theirs, so a publication date at local midnight otherwise rendered as the
// previous day in the server HTML (what crawlers index) and then flipped on
// hydration.
const APP_TIMEZONE = import.meta.env.VITE_APP_TIMEZONE || 'Asia/Amman';

export function formatLongDate(value) {
    if (!value) return null;
    return new Date(value).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: APP_TIMEZONE });
}
